import {Component, OnInit} from "@angular/core";
import {MatDialogRef} from "@angular/material";
import {ProjectService} from "../../services/project.service";
import {NotificationService} from "../../services/notification.service";
import {FreelancersService} from "../../services/freelancers.service";
import {environment} from "../../../environments/environment";
import {Project} from "../../services/model/projects.model";

@Component({
    selector: 'app-outsourcing-dialog',
    templateUrl: 'outsourcing-dialog.component.html',
})
export class OutsourcingDialogComponent implements OnInit{
    public item: any;
    public is_new: boolean;
    public id: string;
    env = environment;
    freelancers: any;
    public started: any;
    public finished: any;

    constructor(
        public dialogRef: MatDialogRef<OutsourcingDialogComponent>,
        private freelancerServ: FreelancersService,
        private projectServ: ProjectService,
        private notifServ: NotificationService
    ) {
    }

    ngOnInit(){

        this.freelancers = this.freelancerServ.getFreelancers('name', 'desc').map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Project;
                const key = a.payload.doc.id;
                return { key, ...data };
            });
        });
    }

    saveService(){
        this.item.started_at = new Date(this.started).getTime();
        this.item.finished_at = new Date(this.finished).getTime();
        if(this.is_new){
            this.projectServ.addService(this.id, this.item).then(
                r => {
                    this.dialogRef.close(true);
                    this.notifServ.sendSuccess( 'Service info have been added');
                }
            )
        }else{
            this.projectServ.updateService(this.id, this.item.key, this.item, true).then(
                r => {
                    this.dialogRef.close(true);
                    this.notifServ.sendSuccess( 'Service info have been updated');
                }
            )
        }

    }

}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/dialogs/outsourcing/outsourcing-dialog.component.ts